import { Inbox } from 'lucide-react';

/**
 * Reusable sidebar navigation item with optional drag-drop support.
 */
export default function SidebarNavItem({
  icon: Icon, label, count, active, onClick, testId,
  droppable, notebookId, onDropToAll,
  dragOverNotebook, setDragOverNotebook, handleNoteDrop, handleNoteDropToAll,
}) {
  const isDropTarget = droppable && dragOverNotebook === (notebookId || 'all');

  return (
    <button
      onClick={onClick}
      data-testid={testId}
      onDragOver={(e) => {
        if (droppable) {
          e.preventDefault();
          setDragOverNotebook?.(notebookId || 'all');
        }
      }}
      onDragLeave={() => setDragOverNotebook?.(null)}
      onDrop={(e) => {
        if (droppable) {
          if (notebookId) handleNoteDrop?.(notebookId, e);
          else if (onDropToAll) handleNoteDropToAll?.(e);
        }
      }}
      className={`w-full flex items-center gap-3 min-h-[44px] py-2.5 px-3 rounded-sm text-sm font-medium transition-colors ${
        isDropTarget
          ? 'bg-accent-amber/20 border-2 border-dashed border-accent-amber text-foreground'
          : active
            ? 'bg-muted text-foreground border-l-2 border-accent-amber -ml-px'
            : 'text-muted-foreground hover:bg-muted/50 hover:text-foreground active:bg-muted/70'
      }`}
    >
      <Icon className="w-[18px] h-[18px] flex-shrink-0" />
      <span className="truncate flex-1 text-left">{label}</span>
      {isDropTarget && <Inbox className="w-4 h-4 text-accent-amber animate-pulse" />}
      {!isDropTarget && count > 0 && (
        <span className="text-xs text-muted-foreground bg-muted/80 rounded-full px-1.5 py-0.5 min-w-[20px] text-center">
          {count}
        </span>
      )}
    </button>
  );
}
